import { inject } from '@angular/core';
import { from, map, Observable, switchMap, take } from 'rxjs';
import { Router } from '@angular/router';
import { AppRoutes, MessagesRoutes } from '@core';
import { ChatChannelType, GetSingleChannelPathParams, GetSingleChannelResponse } from '@core-http';
import { ChatService } from '@messages/infra';
import { ChatInitializer } from '../../../initializers';
import { PENDING_DISPLAY_NAME_QUERY_PARAM, PENDING_USER_ID_QUERY_PARAM } from '../../../constants';

export class OpenSingleChatCommandHandler {
  private readonly chatService: ChatService = inject(ChatService);
  private readonly chatInitializer: ChatInitializer = inject(ChatInitializer);
  private readonly router: Router = inject(Router);

  open(userId: string, displayName?: string): Observable<void> {
    const pathParams: GetSingleChannelPathParams = { userId };

    return this.chatInitializer.init().pipe(
      take(1),
      switchMap(() => this.chatService.getSingleChannel(pathParams)),
      switchMap((channel: GetSingleChannelResponse | null) =>
        channel
          ? this.chatInitializer.openChannel(channel.channelExternalId, ChatChannelType.single)
          : this.navigateToPendingChat(userId, displayName)
      )
    );
  }

  private navigateToPendingChat(userId: string, displayName?: string): Observable<void> {
    return from(
      this.router.navigate([`/${AppRoutes.MESSAGES}/${MessagesRoutes.CHAT}`], {
        queryParams: {
          [PENDING_USER_ID_QUERY_PARAM]: userId,
          [PENDING_DISPLAY_NAME_QUERY_PARAM]: displayName
        }
      })
    ).pipe(map(() => void 0));
  }
}
